import { render, staticRenderFns } from "./IconLeft.vue?vue&type=template&id=4b97bb25&"
import script from "./IconLeft.vue?vue&type=script&lang=js&"
export * from "./IconLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b97bb25')) {
      api.createRecord('4b97bb25', component.options)
    } else {
      api.reload('4b97bb25', component.options)
    }
    module.hot.accept("./IconLeft.vue?vue&type=template&id=4b97bb25&", function () {
      api.rerender('4b97bb25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconLeft.vue"
export default component.exports